import React from 'react'
import { NavLink } from 'react-router-dom'

export default ({ css, nome, icon, url }) =>
    <NavLink className={css} to={url}>
        <span>{icon && <i className={`mr-1 ${icon}`}></i>} {nome}</span>
    </NavLink>


